import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
function getStrictContext<T>(name?: string): readonly [({
  value,
  children
}: {
  value: T;
  children?: React.ReactNode;
}) => React.JSX.Element, () => T] {
  const Context = React.createContext<T | undefined>(undefined);
  const Provider = t0 => {
    const $ = _c(3);
    const {
      value,
      children
    } = t0;
    let t1;
    if ($[0] !== children || $[1] !== value) {
      t1 = <Context.Provider value={value}>{children}</Context.Provider>;
      $[0] = children;
      $[1] = value;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  };
  const useSafeContext = () => {
    const ctx = React.useContext(Context);
    if (ctx === undefined) {
      throw new Error(`useContext must be used within ${name ?? "a Provider"}`);
    }
    return ctx;
  };
  return [Provider, useSafeContext] as const;
}
export { getStrictContext };